import React, { useState, useEffect, useRef } from "react";

import TableHeader from "../../../../../components/Table/Header";
import ModalListaUsuarios from "../../../../../components/ModalListaUsuarios";
import addMore from "../../../../../assets/icons/addMore.png";
import { Checkbox, Dropdown, List, Menu } from "antd";
import { UserOutlined } from "@ant-design/icons";
import "./styles.scss";
import less from "../../../../../assets/icons/less.png";
import TablePagination from "../../../../../components/Table/Pagination";
import Pagination_ from "@mui/material/Pagination";
import { Pagination, PaginationItem } from "@mui/material";

const Destinatarios = ({
  setUsuariosRemovidos,
  idNotificacoesEdicao,
  setUsuariosDestinatarios,
  usuariosDestinatarios,
}) => {
  const [modalUsuarios, setModalUsuarios] = useState(false);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const [inputPagination, setInputPagination] = useState(1);
  const [ordenacao, setOrdenacao] = useState("nome asc");
  const tabelaColunas = [
    <Checkbox onChange={(e) => selecionarTodos(e.target.checked)} />,
    "Nome",
    "Login",
    "E-mail",
    "Nivel de acesso",
  ];

  const showModalUsuarios = () => {
    setModalUsuarios(true);
  };
  const closeModalUsuarios = () => {
    setModalUsuarios(false);
  };
  useEffect(() => {
    console.log("usuariosDestinatarios", usuariosDestinatarios);
  }, [usuariosDestinatarios]);
  const fnSelecionarDestinatarios = (usuario) => {
    var u = [];

    usuariosDestinatarios.map((x) => {
      if (x.id === usuario.id) {
        x.checked ? (x.checked = false) : (x.checked = true);
        u.push(x);
      } else {
        u.push(x);
      }
    });

    setUsuariosDestinatarios(u);
  };
  const removerUsuarios = () => {
    var u = [];
    var v = [];
    usuariosDestinatarios.map((x) => {
      if (!x.checked) {
        u.push(x);
      } else {
        v.push(x);
      }
    });
    setUsuariosDestinatarios(u);
    setUsuariosRemovidos(v);
  };
  const selecionarTodos = (checked) => {
    var u = [];

    usuariosDestinatarios.map((x) => {
      checked ? (x.checked = true) : (x.checked = false);
      u.push(x);
    });

    setUsuariosDestinatarios(u);
  };

  useEffect(() => {
    setPage(1);
  }, [ordenacao]);

  useEffect(() => {
    setPage(1);
  }, [pageSize]);

  const changeInputPagination = (value) => {
    setInputPagination(value === "" ? "" : Number(value));
    setPage(value === "" ? 1 : Number(value));
  };

  useEffect(() => {
    setInputPagination(page);
  }, [page]);

  const handleChange = (e, p) => {
    setPage(p);
    // setInputPagination(page);
  };
  const renderPaginationButtons = () => {
    const pageCount = Math.ceil(usuariosDestinatarios.length / pageSize);
    const paginationButtons = [];

    for (let i = 1; i <= pageCount; i++) {
      paginationButtons.push(
        <PaginationItem
          key={i}
          className={page === i ? "selected-pageNoti" : ""} // Adiciona a classe 'selected' se a página for a página atual
          onClick={(event) => handleChange(event, i)}
        >
          {i}
        </PaginationItem>
      );
    }

    return paginationButtons;
  };

  return (
    <div>
      <div className="row" style={{ borderBottom: "1px solid #898989" }}>
        <div
          style={{ padding: "0px" }}
          className="col-md-7 col-sm-7 col-xl-7 mb-3"
        >
          <span className="titulosPermissoesNotificacoes">Destinatários</span>
        </div>

        <div className="col-md-5 col-sm-5 col-xl-5">
          <span
            onClick={() => showModalUsuarios()}
            className="destinatario mr-3"
          >
            <img src={addMore}></img> Adicionar destinatário
          </span>
          <span
            className="destinatario"
            onClick={(e) => removerUsuarios(e.target.checked)}
          >
            <img src={less}></img> Excluir destinatário
          </span>
        </div>
      </div>

      <div className="row">
        <table className="table table-borderless col-lg-12">
          <tr>
            {tabelaColunas.length > 0 &&
              tabelaColunas.map((coluna, index) => (
                <th
                  onClick={() => {
                    if (coluna == "Nome") {
                      if (ordenacao == "nome asc") {
                        setOrdenacao("nome desc");
                        setUsuariosDestinatarios(
                          usuariosDestinatarios.sort((a, b) =>
                            a.nome.toUpperCase() > b.nome.toUpperCase() ? -1 : 1
                          )
                        );
                      } else {
                        setOrdenacao("nome asc");
                        setUsuariosDestinatarios(
                          usuariosDestinatarios.sort((a, b) =>
                            a.nome.toUpperCase() < b.nome.toUpperCase() ? -1 : 1
                          )
                        );
                      }
                    }

                    if (coluna == "Login") {
                      if (ordenacao == "login asc") {
                        setOrdenacao("login desc");
                        setUsuariosDestinatarios(
                          usuariosDestinatarios.sort((a, b) =>
                            a.login.toUpperCase() > b.login.toUpperCase()
                              ? -1
                              : 1
                          )
                        );
                      } else {
                        setOrdenacao("login asc");
                        setUsuariosDestinatarios(
                          usuariosDestinatarios.sort((a, b) =>
                            a.login.toUpperCase() < b.login.toUpperCase()
                              ? -1
                              : 1
                          )
                        );
                      }
                    }

                    if (coluna == "E-mail") {
                      if (ordenacao == "email asc") {
                        setOrdenacao("email desc");
                        setUsuariosDestinatarios(
                          usuariosDestinatarios.sort((a, b) =>
                            a.email.toUpperCase() > b.email.toUpperCase()
                              ? -1
                              : 1
                          )
                        );
                      } else {
                        setOrdenacao("email asc");
                        setUsuariosDestinatarios(
                          usuariosDestinatarios.sort((a, b) =>
                            a.email.toUpperCase() < b.email.toUpperCase()
                              ? -1
                              : 1
                          )
                        );
                      }
                    }

                    if (coluna == "Nivel de acesso") {
                      if (ordenacao == "nivelAcesso asc") {
                        setOrdenacao("nivelAcesso desc");
                        setUsuariosDestinatarios(
                          usuariosDestinatarios.sort((a, b) =>
                            a.nivelAcesso.toUpperCase() >
                            b.nivelAcesso.toUpperCase()
                              ? -1
                              : 1
                          )
                        );
                      } else {
                        setOrdenacao("nivelAcesso asc");
                        setUsuariosDestinatarios(
                          usuariosDestinatarios.sort((a, b) =>
                            a.nivelAcesso.toUpperCase() <
                            b.nivelAcesso.toUpperCase()
                              ? -1
                              : 1
                          )
                        );
                      }
                    }
                  }}
                  style={{ cursor: "pointer" }}
                  key={index}
                >
                  {" "}
                  {coluna}
                  {coluna === "Nome" && ordenacao === "nome desc" && (
                    <span>&#9650;</span>
                  )}
                  {coluna === "Nome" && ordenacao === "nome asc" && (
                    <span>&#9660;</span>
                  )}
                  {coluna === "Login" && ordenacao === "login desc" && (
                    <span>&#9650;</span>
                  )}
                  {coluna === "Login" && ordenacao === "login asc" && (
                    <span>&#9660;</span>
                  )}
                  {coluna === "E-mail" && ordenacao === "email desc" && (
                    <span>&#9650;</span>
                  )}
                  {coluna === "E-mail" && ordenacao === "email asc" && (
                    <span>&#9660;</span>
                  )}
                  {coluna === "Nivel de acesso" &&
                    ordenacao === "nivelAcesso desc" && <span>&#9650;</span>}
                  {coluna === "Nivel de acesso" &&
                    ordenacao === "nivelAcesso asc" && <span>&#9660;</span>}
                </th>
              ))}
          </tr>
          <tbody>
            {usuariosDestinatarios.map(
              (item, index) =>
                index < page * pageSize &&
                index >= page * pageSize - pageSize && (
                  <tr key={index}>
                    <td>
                      <span>
                        <Checkbox
                          style={{ marginTop: "-9px" }}
                          checked={item.checked}
                          onChange={() => fnSelecionarDestinatarios(item)}
                        />
                      </span>
                    </td>
                    <td>
                      <span className="coluna-nome m-0 p-0">
                        <span className="m-0 p-0">{item.nome}</span>
                      </span>
                    </td>
                    <td> {item.login} </td>
                    <td> {item.email} </td>
                    <td> {item.nivelAcesso} </td>
                  </tr>
                )
            )}
          </tbody>
        </table>

        <div className="PaginationContainer">
          <div className="row">
            <div className="col-12 mt20" style={{ marginRight: "120px" }}></div>
          </div>
          <div className="row">
            <div className="col-12 mt20" style={{ display: "flex" }}>
              <Pagination
                count={Math.ceil(usuariosDestinatarios.length / pageSize)}
                defaultPage={1}
                variant="outlined"
                shape="rounded"
                onChange={handleChange}
                color="secondary"
                page={page}
              >
                {renderPaginationButtons()}
              </Pagination>
              <div className="div-iput-page">
                <input
                  className="input-pagination"
                  onChange={(e) => changeInputPagination(e.target.value)}
                  type="number"
                  value={inputPagination}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {modalUsuarios === true && (
        <ModalListaUsuarios
          closeModal={closeModalUsuarios}
          usuarios={usuariosDestinatarios}
          setUsuarios={setUsuariosDestinatarios}
          openModal={modalUsuarios}
        />
      )}
    </div>
  );
};

export default Destinatarios;
